import { useMemo } from "react";

import { createOperationClient } from "@/services/react-query.service/graphql-client";
import { queryKeys } from "@/services/react-query.service/query-keys";
import { useQuery } from "@tanstack/react-query";

import { getLabelQueryDocument } from "./label.gql";

export interface UseGetLabelProps {
  id?: string | null;
  enabled?: boolean;
}

export const useGetLabel = ({ id, enabled = true }: UseGetLabelProps) => {
  const queryResult = useQuery({
    queryKey: queryKeys.labels.detail(id ?? ""),
    queryFn: async () => {
      if (!id) {
        throw new Error("Label ID is required");
      }

      const client = createOperationClient("GetLabel");
      const data = await client.request(getLabelQueryDocument, { input: { id } });

      return data.label;
    },
    enabled: enabled && !!id,
    staleTime: 5 * 60 * 1000, // 5 minutes for individual items
  });

  const label = useMemo(() => {
    return queryResult.data ?? null;
  }, [queryResult.data]);

  return {
    label,
    loading: queryResult.isLoading,
    error: queryResult.error,
    queryResult,
  };
};
